function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 358.49,
    rx: 222.5,
    ry: 128.46
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadows"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E6E6E6"
    },
    cx: 95.58,
    cy: 369.76,
    rx: 24.63,
    ry: 14.22
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M285.26,293.53l-161.88,93.46c-2.68,1.55-2.68,5.42,0,6.98l95.14,54.93 c4.87,2.81,10.87,2.81,15.73,0l161.88-93.46c2.68-1.55,2.68-5.42,0-6.97l-95.14-54.93C296.12,290.72,290.13,290.72,285.26,293.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M236.65,294.44l-64.81,37.42c-5.7,3.29-5.7,11.52,0,14.82l32.64,18.84c4.39,2.54,9.81,2.54,14.2,0 l64.81-37.42c5.7-3.29,5.7-11.52,0-14.82l-32.64-18.84C246.46,291.9,241.05,291.9,236.65,294.44z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M96.88,332.96c0,0-15.22-14.86-6.56-39.76c4.85-13.95,20.94-24.2,30.1-25.16 c0,0-4.97,5.73-7.16,12.07l-11.54,7.67l10.61-3.32l-2.26,9.08c0,0-9.86,5.96-11.33,7.27l10.63-2.78 C109.38,298.01,108.56,323.72,96.88,332.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M96.88,332.96c0,0-15.22-14.86-6.56-39.76c4.85-13.95,20.94-24.2,30.1-25.16 c0,0-4.97,5.73-7.16,12.07l-11.54,7.67l10.61-3.32l-2.26,9.08c0,0-9.86,5.96-11.33,7.27l10.63-2.78 C109.38,298.01,108.56,323.72,96.88,332.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M96.88,332.96c0,0-7.88-31.1,3.78-49.24C100.66,283.71,86.99,299.72,96.88,332.96z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M114.3,337.17l-18.62-0.23v0l-0.1,0l-0.1,0v0l-18.62,0.23c0,0-0.21,22.94,6.86,32.28h0 c1.95,2.48,6.53,4.22,11.86,4.22c5.34,0,9.92-1.75,11.87-4.24C114.5,360.09,114.3,337.17,114.3,337.17z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#455A64"
    },
    cx: 95.58,
    cy: 337.17,
    rx: 18.72,
    ry: 10.05
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M95.58,334.5c6.44,0,11.89,2.07,13.82,4.93c0.48-0.71,0.75-1.47,0.75-2.26 c0-3.97-6.52-7.19-14.56-7.19c-8.04,0-14.56,3.22-14.56,7.19c0,0.79,0.27,1.55,0.75,2.26C83.68,336.57,89.14,334.5,95.58,334.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E0E0E0"
    },
    cx: 95.58,
    cy: 339.43,
    rx: 13.81,
    ry: 4.93
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M95.81,340.67c0,0-7.21-0.28-13.4-9.86c-2.55-3.95-3.78-6.03-3.78-6.03l10.05-0.75l-11.26-2.81 l-5.32-8.14l9.35-0.69c0,0-6.96-2.44-11.94-2.47c0,0-8.62-15.23-11.15-17.4c0,0,19.89,0.16,34.06,16.93S97.91,341.1,95.81,340.67 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M95.81,340.67c0,0,4.51-27.18-24.28-43.52C71.53,297.15,101.41,311.5,95.81,340.67z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M95.81,340.67c0,0,6.53,0.43,13.02-7.63c2.67-3.32,3.98-5.08,3.98-5.08l-9-1.62l10.42-1.48 l5.57-6.84l-8.37-1.51c0,0,6.51-1.55,11-1.11c0,0,9.21-12.93,11.69-14.65c0,0-17.96-1.72-32.33,12.06S93.87,340.86,95.81,340.67z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M95.81,340.67c0,0,6.53,0.43,13.02-7.63c2.67-3.32,3.98-5.08,3.98-5.08l-9-1.62l10.42-1.48 l5.57-6.84l-8.37-1.51c0,0,6.51-1.55,11-1.11c0,0,9.21-12.93,11.69-14.65c0,0-17.96-1.72-32.33,12.06S93.87,340.86,95.81,340.67z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M95.81,340.67c0,0-1.51-24.94,26-36.98C121.81,303.69,93.5,313.83,95.81,340.67z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Pictures"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    points: "128.91,119.4 128.91,169.08 85.88,193.92 85.88,144.24 128.91,119.4  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M124.25,122.09v44.3l-38.37,22.15v-44.3L124.25,122.09 M126.58,118.05l-43.02,24.84v49.68 l2.33,1.34l43.02-24.84V119.4L126.58,118.05L126.58,118.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M126.58,123.43v44.3l-38.37,22.15v-44.3L126.58,123.43 M128.91,119.4l-43.02,24.84v49.68 l43.02-24.84V119.4L128.91,119.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "122.59,157.71 90.04,176.5 99.66,151.48 106.32,159.39 113.13,149.7  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M111.3,142.1c0,1.89-1.33,4.2-2.97,5.14c-1.64,0.95-2.97,0.18-2.97-1.71 c0-1.89,1.33-4.2,2.97-5.14C109.97,139.44,111.3,140.21,111.3,142.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    points: "143.26,57.54 143.26,97.12 108.99,116.91 108.99,77.33 143.26,57.54  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M139.55,59.69v35.29l-30.56,17.65V77.33L139.55,59.69 M141.41,56.47l-34.28,19.79v39.58l1.86,1.07 l34.27-19.79V57.54L141.41,56.47L141.41,56.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M141.41,60.76v35.29l-30.56,17.65V78.4L141.41,60.76 M143.26,57.54l-34.27,19.79v39.58l34.27-19.79 V57.54L143.26,57.54z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "138.23,88.07 112.3,103.04 119.96,83.11 125.27,89.41 130.69,81.68  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M129.24,75.63c0,1.51-1.06,3.34-2.37,4.1c-1.31,0.75-2.37,0.14-2.37-1.37s1.06-3.34,2.37-4.1 C128.18,73.51,129.24,74.13,129.24,75.63z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M216.15,286.33l13.91,84.89c0.21,1.28,1.32,2.22,2.61,2.22l0,0c1.58,0,2.81-1.37,2.63-2.94 l-9.76-87.58L216.15,286.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M264.17,257.78l13.91,84.89c0.21,1.28,1.32,2.22,2.61,2.22l0,0c1.58,0,2.81-1.37,2.63-2.94 l-9.76-87.58L264.17,257.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M194.8,266.48l-13.73,73.15c-0.19,1.06-1.11,1.82-2.19,1.82c-1.35,0-2.4-1.21-2.21-2.55 l10.14-67.8L194.8,266.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M243.36,239.19l-13.65,72.7c-0.19,1.06-1.11,1.82-2.19,1.82c-1.35,0-2.4-1.21-2.21-2.55 l10.06-67.36L243.36,239.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M239.4,233.65c-6.41-2.86-10.8-8.9-11.49-15.88c-2.21-22.27-10.06-68.18-36.64-52.9 c-32.81,18.86-21.06,73.63-16.29,91.19c1.08,3.96,3.14,7.57,6.03,10.49c5.93,5.97,18.2,16.25,39.07,25.01 c2.56,1.07,5.41,1.24,8.08,0.48c10.37-2.95,37.46-12.03,50.97-29.3c1.6-2.04,1.25-4.99-0.78-6.6 C272.88,251.8,260.51,243.07,239.4,233.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M239.4,233.65c-6.41-2.86-10.8-8.9-11.49-15.88c-2.21-22.27-10.06-68.18-36.64-52.9 c-32.81,18.86-21.06,73.63-16.29,91.19c1.08,3.96,3.14,7.57,6.03,10.49c5.93,5.97,18.2,16.25,39.07,25.01 c2.56,1.07,5.41,1.24,8.08,0.48c10.37-2.95,37.46-12.03,50.97-29.3c1.6-2.04,1.25-4.99-0.78-6.6 C272.88,251.8,260.51,243.07,239.4,233.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M280.11,259.61c0.06,1.1-0.25,2.21-0.98,3.14c-0.72,0.92-1.49,1.82-2.28,2.69l0,0c0,0,0,0,0,0 c-0.43,0.48-0.88,0.95-1.33,1.42c-0.01,0.01-0.02,0.02-0.03,0.03c-0.45,0.46-0.91,0.91-1.37,1.36 c-0.01,0.01-0.03,0.03-0.04,0.04c-0.47,0.45-0.94,0.88-1.43,1.32c-0.01,0.01-0.02,0.02-0.04,0.03 c-0.49,0.44-0.98,0.86-1.48,1.29c-0.01,0.01-0.01,0.01-0.02,0.02c-7.66,6.43-16.96,11.33-25.27,14.86 c-0.01,0-0.02,0.01-0.03,0.01c-0.52,0.22-1.03,0.43-1.54,0.64c-0.05,0.02-0.11,0.04-0.16,0.07c-0.48,0.2-0.95,0.39-1.42,0.57 c-0.08,0.03-0.16,0.07-0.25,0.1c-0.45,0.18-0.88,0.35-1.32,0.52c-0.1,0.04-0.2,0.08-0.3,0.12c-0.42,0.16-0.83,0.31-1.23,0.47 c-0.12,0.04-0.24,0.09-0.36,0.13c-0.38,0.14-0.76,0.28-1.14,0.42c-0.14,0.05-0.27,0.1-0.41,0.15c-0.35,0.13-0.7,0.25-1.05,0.37 c-0.15,0.05-0.29,0.1-0.44,0.15c-0.33,0.11-0.65,0.23-0.97,0.33c-0.16,0.05-0.31,0.1-0.46,0.16c-0.3,0.1-0.59,0.2-0.88,0.29 c-0.17,0.06-0.33,0.11-0.5,0.16c-0.27,0.09-0.53,0.17-0.79,0.25c-0.18,0.06-0.36,0.11-0.53,0.17c-0.23,0.07-0.46,0.15-0.68,0.22 c-0.2,0.06-0.38,0.12-0.58,0.18c-0.19,0.06-0.39,0.12-0.58,0.18c-0.24,0.07-0.47,0.14-0.7,0.21c-0.12,0.04-0.24,0.07-0.36,0.11 c-0.35,0.1-0.68,0.2-1,0.29c-2.67,0.76-5.52,0.59-8.08-0.48c-20.87-8.76-33.15-19.04-39.07-25.01 c-2.89-2.91-4.95-6.53-6.03-10.49c-4.77-17.56-16.52-72.33,16.29-91.19c0.58-0.33,1.15-0.63,1.72-0.91 c0.12-0.06,0.25-0.12,0.37-0.18c0.55-0.26,1.1-0.5,1.64-0.71c0.05-0.02,0.1-0.04,0.16-0.06c0.52-0.19,1.02-0.36,1.52-0.51 c0.08-0.02,0.15-0.05,0.23-0.07c0.54-0.15,1.07-0.27,1.59-0.37c0.04-0.01,0.09-0.01,0.13-0.02c1.09-0.19,2.13-0.26,3.15-0.22 c0.02,0,0.04,0,0.06,0c1.03,0.04,2.03,0.2,2.98,0.46c0,0,0,0,0,0c-5.24-2.32-11.64-2.21-17.99,1.44 c-32.81,18.86-21.06,73.63-16.29,91.19l0.81,3.02c1.63,6.09,5.23,11.48,10.24,15.31l8.51,6.51v0 c6.89,5.3,16.67,11.49,29.95,17.06c2.57,1.08,5.43,1.26,8.11,0.5c10.36-2.95,37.47-12.02,50.98-29.3 c0.6-0.77,0.91-1.67,0.97-2.57h0.02v-5.85L280.11,259.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6
    },
    d: "M280.11,259.61c0.06,1.1-0.25,2.21-0.98,3.14c-0.72,0.92-1.49,1.82-2.28,2.69l0,0c0,0,0,0,0,0 c-0.43,0.48-0.88,0.95-1.33,1.42c-0.01,0.01-0.02,0.02-0.03,0.03c-0.45,0.46-0.91,0.91-1.37,1.36 c-0.01,0.01-0.03,0.03-0.04,0.04c-0.47,0.45-0.94,0.88-1.43,1.32c-0.01,0.01-0.02,0.02-0.04,0.03 c-0.49,0.44-0.98,0.86-1.48,1.29c-0.01,0.01-0.01,0.01-0.02,0.02c-7.66,6.43-16.96,11.33-25.27,14.86 c-0.01,0-0.02,0.01-0.03,0.01c-0.52,0.22-1.03,0.43-1.54,0.64c-0.05,0.02-0.11,0.04-0.16,0.07c-0.48,0.2-0.95,0.39-1.42,0.57 c-0.08,0.03-0.16,0.07-0.25,0.1c-0.45,0.18-0.88,0.35-1.32,0.52c-0.1,0.04-0.2,0.08-0.3,0.12c-0.42,0.16-0.83,0.31-1.23,0.47 c-0.12,0.04-0.24,0.09-0.36,0.13c-0.38,0.14-0.76,0.28-1.14,0.42c-0.14,0.05-0.27,0.1-0.41,0.15c-0.35,0.13-0.7,0.25-1.05,0.37 c-0.15,0.05-0.29,0.1-0.44,0.15c-0.33,0.11-0.65,0.23-0.97,0.33c-0.16,0.05-0.31,0.1-0.46,0.16c-0.3,0.1-0.59,0.2-0.88,0.29 c-0.17,0.06-0.33,0.11-0.5,0.16c-0.27,0.09-0.53,0.17-0.79,0.25c-0.18,0.06-0.36,0.11-0.53,0.17c-0.23,0.07-0.46,0.15-0.68,0.22 c-0.2,0.06-0.38,0.12-0.58,0.18c-0.19,0.06-0.39,0.12-0.58,0.18c-0.24,0.07-0.47,0.14-0.7,0.21c-0.12,0.04-0.24,0.07-0.36,0.11 c-0.35,0.1-0.68,0.2-1,0.29c-2.67,0.76-5.52,0.59-8.08-0.48c-20.87-8.76-33.15-19.04-39.07-25.01 c-2.89-2.91-4.95-6.53-6.03-10.49c-4.77-17.56-16.52-72.33,16.29-91.19c0.58-0.33,1.15-0.63,1.72-0.91 c0.12-0.06,0.25-0.12,0.37-0.18c0.55-0.26,1.1-0.5,1.64-0.71c0.05-0.02,0.1-0.04,0.16-0.06c0.52-0.19,1.02-0.36,1.52-0.51 c0.08-0.02,0.15-0.05,0.23-0.07c0.54-0.15,1.07-0.27,1.59-0.37c0.04-0.01,0.09-0.01,0.13-0.02c1.09-0.19,2.13-0.26,3.15-0.22 c0.02,0,0.04,0,0.06,0c1.03,0.04,2.03,0.2,2.98,0.46c0,0,0,0,0,0c-5.24-2.32-11.64-2.21-17.99,1.44 c-32.81,18.86-21.06,73.63-16.29,91.19l0.81,3.02c1.63,6.09,5.23,11.48,10.24,15.31l8.51,6.51v0 c6.89,5.3,16.67,11.49,29.95,17.06c2.57,1.08,5.43,1.26,8.11,0.5c10.36-2.95,37.47-12.02,50.98-29.3 c0.6-0.77,0.91-1.67,0.97-2.57h0.02v-5.85L280.11,259.61z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M298.21,322.28c-2.25-14.28-5.11-37.12-6.76-50.63c-0.11-0.89-0.26-1.77-0.45-2.63 c-1.65-7.54-6.59-13.95-13.22-17.9l-33.66-20.04l-22.85-12.02c0,0-6.08,17.62,0.98,28.39c5.88,8.97,31.84,20.09,39.55,23.83 c7.71,3.74,7.88,4.76,7.72,9.77s-0.17,11.39,9.32,31.37c2.72,5.74,4.62,10.04,5.95,13.33 C288.11,326.05,293.02,325.64,298.21,322.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7
    },
    d: "M298.21,322.28c-2.25-14.28-5.11-37.12-6.76-50.63c-0.16-1.33-0.42-2.64-0.76-3.92 c-1.87-6.99-6.63-12.87-12.85-16.57l-33.71-20.07l-22.85-12.02c0,0-6.08,17.62,0.98,28.39c5.88,8.97,31.84,20.09,39.55,23.83 c7.71,3.74,7.88,4.76,7.72,9.77s-0.17,11.39,9.32,31.37c2.72,5.74,4.62,10.04,5.95,13.33 C288.11,326.05,293.02,325.64,298.21,322.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M287.8,337.41c-0.01,0.6,0.12,1.18,0.41,1.7c0.63,1.15,2.06,3.32,5.06,6.02 c4.53,4.09,19.56,20.09,24.85,10.16c0,0-15.53-14.87-17.59-20.99c-0.58-1.74-1.4-6.17-2.32-12.03 c-5.19,3.36-10.1,3.77-13.4,3.48C287.72,332.99,287.85,335.35,287.8,337.41z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M303.96,336.43l-0.43-1.29c-0.33-1-1.41-1.55-2.42-1.24l-6.29,1.94 c-0.81,0.25-1.36,1-1.36,1.85v0.63c0,0.62-0.5,1.12-1.12,1.12l0,0c-1.33,0-2.62-0.46-3.65-1.31l-0.88-0.72v-2.2l0,0 c-1.16,0.75-1.83,2.06-1.75,3.44c0.08,1.49,0.15,3.31,0.1,4.04c-0.1,1.31-1.34,6.82,0.14,8.45c1.47,1.63,4.77,1.82,8.85,1.38 c4.08-0.44,8.54,3.58,12.33,5.06s19.44,4.69,19.4-5.32c-0.01-2.55-2.53-3.59-5.01-4.49c-2.48-0.9-11.41-4.05-13.7-5.94 c-1.05-0.87-1.92-1.78-2.55-2.52C304.86,338.46,304.31,337.49,303.96,336.43z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M307.45,357.57c-3.78-1.49-8.25-5.5-12.33-5.06c-4.08,0.44-7.37,0.25-8.85-1.38 c-0.44-0.49-0.64-1.33-0.7-2.31c-0.08,1.54,0.04,3.02,0.7,3.74c1.47,1.63,4.77,1.82,8.85,1.38 c4.08-0.44,8.54,3.58,12.33,5.06c3.78,1.49,19.44,4.69,19.4-5.32c0-0.16-0.04-0.29-0.06-0.43 C325.8,362.04,311.1,359,307.45,357.57z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M267.64,339.62c-2.25-14.28-5.11-37.12-6.76-50.63c-0.86-7.1-4.37-13.61-9.82-18.24 l-40.39-34.34l-21.59-0.37c0,0-4.45,17.99,2.61,28.77c5.88,8.97,31.84,20.09,39.55,23.83c7.71,3.74,7.88,4.76,7.72,9.77 c-0.16,5.01-0.17,11.39,9.32,31.37c2.72,5.74,4.62,10.04,5.95,13.33C257.54,343.39,262.44,342.98,267.64,339.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7
    },
    d: "M267.64,339.62c-2.25-14.28-5.11-37.12-6.76-50.63c-0.86-7.1-4.37-13.61-9.82-18.24l-40.39-34.34 l-21.59-0.37c0,0-4.45,17.99,2.61,28.77c5.88,8.97,31.84,20.09,39.55,23.83c7.71,3.74,7.88,4.76,7.72,9.77 c-0.16,5.01-0.17,11.39,9.32,31.37c2.72,5.74,4.62,10.04,5.95,13.33C257.54,343.39,262.44,342.98,267.64,339.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M257.21,353.46c-0.01,0.6-0.41,2.37,0.42,2.99c1.05,0.78,2.06,3.32,5.06,6.02 c4.53,4.09,9.32-4.71,7.26-10.83c-0.58-1.74-1.4-6.17-2.32-12.03c-5.19,3.36-10.1,3.77-13.4,3.48 C257.15,350.33,257.27,351.41,257.21,353.46z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M230.52,161.52L230.52,161.52c6.38-1,12.59,2.73,14.61,8.86c1.22,3.68,2.31,8.18,2.73,13.21 c1.17,13.85,1.49,20.78,1.49,20.78l13.91,6.31c0,0-7.51,0.36-7,10.97l-17.33-4.37L230.52,161.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M249.86,196c-2.05-15.01-2.86-22.85-4.62-26.57c-2.76-5.84-8.34-8.9-14.72-7.9l5.24,41.2 l0.68-0.07c4.64-0.45,9.01-2.39,12.47-5.51L249.86,196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M249.86,196c-2.05-15.01-2.86-22.85-4.62-26.57c-2.76-5.84-8.34-8.9-14.72-7.9l5.24,41.2 l0.68-0.07c4.64-0.45,9.01-2.39,12.47-5.51L249.86,196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M249.35,204.37c0,0-2.65,0.78-4.11,2.52c0,0,1.68-3.19,4.03-4.17L249.35,204.37z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M197.1,173.67l15.56-7.54l12.82-4.43c0,0,10.27-3.28,12.9,10.41c2.16,11.25,2.44,54.01,2.44,54.01 l-0.23,4.68c0,0-5.93,16.62-27.12,17.99c-21.19,1.37-25.31-7.56-25.31-7.56S186.02,184.66,197.1,173.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M246.13,127.96c0,0,4.81,12.33-1.83,17.76c-6.64,5.43-4.34-16.38-4.34-16.38L246.13,127.96z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M234.41,445.41c-1.51,0.87-3.95,0.87-5.46,0c-1.51-0.87-1.51-2.28,0-3.15 c1.51-0.87,3.95-0.87,5.46,0C235.92,443.13,235.92,444.54,234.41,445.41z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.83,
    y: 350.79,
    style: {
      fill: "#37474F"
    },
    width: 7.72,
    height: 92.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#455A64"
    },
    cx: 143.87,
    cy: 392.27,
    rx: 3.86,
    ry: 2.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.01,
    y: 299.23,
    style: {
      fill: "#263238"
    },
    width: 7.72,
    height: 92.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M378.36,362.01c-1.51,0.87-3.95,0.87-5.46,0c-1.51-0.87-1.51-2.28,0-3.15 c1.51-0.87,3.95-0.87,5.46,0C379.87,359.73,379.87,361.14,378.36,362.01z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.78,
    y: 267.39,
    style: {
      fill: "#37474F"
    },
    width: 7.72,
    height: 92.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M283.96,291.66c-1.35,0.78-3.55,0.78-4.9,0c-1.35-0.78-1.35-2.05,0-2.83 c1.35-0.78,3.55-0.78,4.9,0C285.31,289.62,285.31,290.88,283.96,291.66z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.05,
    y: 212.6,
    style: {
      fill: "#455A64"
    },
    width: 6.93,
    height: 77.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "140.01,283.83 140.01,302.32 231.69,355.26 231.69,336.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#37474F"
    },
    points: "379.5,251.43 231.69,336.76 231.69,355.26 379.5,269.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#455A64"
    },
    points: "287.81,198.49 140.01,283.83 231.69,336.76 379.5,251.43  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "213.66,256.08 247.28,275.49 303.17,243.16 269.56,223.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "243.66,250.55 256.27,243.27 248.37,238.71 235.76,245.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "248.71,270.64 231.72,260.64 264.92,240.54  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M258.22,208.28l13.45,6.31c5.39,1.26,11.88,3.67,11.88,3.67s9.36,3.82,9.78,6.33 c0.43,2.51-7.02,8.55-13.57,5.61c-1.32-0.59-3.7-1.79-5.46-1.98c-1.76-0.19-6.97-1.01-10.75-4.61l-15.7-4.08 C247.86,219.54,247.08,209.84,258.22,208.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M266.93,227.04c1.56,1.67,6,5.88,6.97,7.09c0.97,1.22,3.26-1.91-0.76-6.57 c0,0-5.34-1.85-9.69-5.28C263.45,222.29,265.37,225.38,266.93,227.04z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 212.66,
    y: 146.81,
    style: {
      fill: "#FFA8A7"
    },
    width: 15.96,
    height: 19.32
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M228.63,166.13c-5.64-2.18-11.54-6.55-14.67-13.95v-5.37h14.67V166.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M234,121.3c0,0,14.52,1.75,11.19,26.55c-1.54,11.47-4.61,17.27-13.45,16.29 c-10.02-1.11-23.87-8.9-21.72-28.55C212.16,115.94,234,121.3,234,121.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F28F8F"
    },
    points: "234.81,143.42 234.29,151.99 239.4,150.76  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M227.21,142.65c-0.06,0.96,0.67,1.79,1.64,1.85c0.96,0.06,1.79-0.67,1.85-1.64 c0.06-0.96-0.67-1.79-1.64-1.85C228.1,140.95,227.27,141.69,227.21,142.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M238.76,142.14c-0.06,0.96,0.67,1.79,1.64,1.85c0.96,0.06,1.79-0.67,1.85-1.64 c0.06-0.96-0.67-1.79-1.64-1.85C239.65,140.44,238.82,141.17,238.76,142.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M242.86,138.74l-3.29-2.24c0,0,1.39-1.28,2.65-0.38C243.47,137.02,242.86,138.74,242.86,138.74z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M228.42,138.35l-3.55,1.79c0,0-0.44-1.84,0.95-2.5C227.22,136.98,228.42,138.35,228.42,138.35z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M234.54,155.47c0,0-3.33,0.1-5.53-1.85c0,0-0.57,2.94,1.88,3.65 C233.33,157.99,234.54,155.47,234.54,155.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M212.49,143.22c0,0,2.24,4.64,3.61,4.48s0-17.8,2.86-17.92c2.86-0.11,16.36,6.59,28.29-2.06 c4.58-3.32,5.5-11.8,2.75-11c-2.75,0.8-6.46,3.21-11.48,2.86c-5.02-0.34-22.54-8.48-26.9,2.98c0,0-9.71-0.79-6.06,18.47 c0.91,4.78,3.77,16.65,7.09,17.82L212.49,143.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M213.28,147.46c0.04-1.45-0.19-2.91-0.79-4.24c-0.67-1.49-1.84-2.98-3.88-3.04 c-4.48-0.12-5.09,4.19-5.03,5.73c0.16,4.04,3.43,8.4,9.51,8.56L213.28,147.46z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M214.66,233.91l11.44,9.06c0,0,3.62,0.35,5.8,1.01c2.19,0.66,7.93,2.77,9.45,3.1 c1.52,0.33-0.44,2.94-4.42,1.99c0,0,8.34,5.71,8.23,8.26c-0.11,2.54-8.67,6.88-14.45,2.62c-1.16-0.86-3.24-2.53-4.92-3.09 c-1.68-0.55-6.6-2.46-9.53-6.78l-10-5.21C206.26,244.87,203.44,233.08,214.66,233.91z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M202.18,171.21c0,0,6.68,5.18,2.57,21.24c-4.1,16.07-6.29,29.92-6.29,29.92l16.21,11.54 c0,0-6.85,2.44-8.4,10.96c0,0-25.54-10.04-26.06-16.49c-0.52-6.44,5.33-34.35,6.22-39.48 C187.31,183.77,191.85,173.64,202.18,171.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M198.46,222.37c0,0-3.29-0.7-6.11,0.06c0,0,2.5-1.55,6.25-1.55L198.46,222.37z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M310.97,206.13l-5.84,38.26c0,0.03-0.02,0.05-0.04,0.06l-58.06,33.67 c-0.06,0.04-0.14-0.02-0.13-0.09l5.67-37.1c0.24-1.6,1.18-3.01,2.56-3.86l53.26-32.66C309.62,203.65,311.19,204.69,310.97,206.13 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M247.02,278.12l-31.01-17.96c-1.46-0.84-2.35-2.4-2.35-4.08l0,0l33.62,19.41L247.02,278.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M277.37,242.99c0,2.73,1.92,3.84,4.28,2.47c2.37-1.37,4.28-4.69,4.28-7.42 c0-2.73-1.92-3.84-4.28-2.47C279.29,236.94,277.37,240.26,277.37,242.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M213.17,128.21c0,0-2.63-3.89-1.03-5.15C213.74,121.79,215,125.8,213.17,128.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M213.61,129.02c0,0-4.67-0.58-4.56-2.62C209.16,124.37,213.01,126.06,213.61,129.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M212.66,166.13c0,0,3.42,9.02,11.33,7.88c7.9-1.15,4.64-7.88,4.64-7.88H212.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M202.18,171.21c0,0,5.2,2.49,4.4,12.95c-0.8,10.46-4.93,31.54-4.93,31.54s-18.62,7.53-20.39-3.09 c-0.46-2.75,4.24-28.18,8.25-33.56C193.52,173.66,198.05,171.95,202.18,171.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M202.18,171.21c0,0,5.2,2.49,4.4,12.95c-0.8,10.46-4.93,31.54-4.93,31.54s-18.62,7.53-20.39-3.09 c-0.46-2.75,4.24-28.18,8.25-33.56C193.52,173.66,198.05,171.95,202.18,171.21z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M257.63,353.98c0,0,1.16,1.83,3.04,2.12c1.13,0.18-1.16-2.75,1.57-3.93 c2.72-1.17,8.95-2.8,9.51-0.45l0.69,2.92c0.65,2.76,1.97,5.32,3.84,7.45c1.87,2.13,4.29,4.67,6.16,5.88 c3.56,2.3,9.4,7.85,1.9,12.57c-7.51,4.72-16.74,0.74-18.54-4.64c-1.81-5.38-3.72-6.93-4.68-7.82c-0.96-0.89-3.21-2.29-4.06-5.92 c-0.55-2.35-0.86-5.37-1.02-7.2c-0.08-1,0.39-1.95,1.24-2.49l0,0L257.63,353.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M284.34,380.55c-7.51,4.72-16.74,0.74-18.54-4.64c-1.81-5.38-3.72-6.93-4.68-7.82 c-0.86-0.8-2.75-2.02-3.74-4.87c0.01,0.15,0.03,0.3,0.04,0.44c0.29,4.65,3.14,5.74,4.1,6.64c0.96,0.89,2.54,2.37,4.35,7.74 c1.81,5.38,11.33,8.73,18.83,4c3.64-2.29,4.14-4.78,3.28-6.99C288.11,376.85,287.19,378.76,284.34,380.55z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M248.26,309.16l-23.92,13.81l-30.19-17.43l23.97-13.84c0.63-0.37,1.42-0.37,2.05,0l28.09,16.22 C248.74,308.2,248.74,308.89,248.26,309.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7
    },
    d: "M248.26,309.16l-23.92,13.81l-30.19-17.43l23.97-13.84c0.63-0.37,1.42-0.37,2.05,0l28.09,16.22 C248.74,308.2,248.74,308.89,248.26,309.16z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M246.6,308.66l-22.27,12.86l-28.1-16.23l22.31-12.88c0.59-0.34,1.32-0.34,1.91,0l26.15,15.1 C247.05,307.76,247.05,308.4,246.6,308.66z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "224.34,321.51 224.34,319 246.94,305.96 246.94,308.09  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "224.34,321.51 224.34,319 196.23,302.78 196.23,305.29  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M248.26,305.19L224.34,319l-30.19-17.43l23.97-13.84c0.63-0.37,1.42-0.37,2.05,0l28.09,16.22 C248.74,304.23,248.74,304.92,248.26,305.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M248.26,305.19L224.34,319l-30.19-17.43l23.97-13.84c0.63-0.37,1.42-0.37,2.05,0l28.09,16.22 C248.74,304.23,248.74,304.92,248.26,305.19z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M221.21,321.17c-0.15,0.06-0.31,0.05-0.45-0.03c-0.18-0.1-0.29-0.27-0.29-0.48v-2.27 c0-1.04,0.56-2.02,1.45-2.55l0.09-0.05c0.12-0.07,0.23-0.03,0.27,0c0.04,0.02,0.14,0.09,0.14,0.23c0,0.26,0.21,0.47,0.47,0.47 c0.26,0,0.47-0.21,0.47-0.47c0-0.44-0.23-0.83-0.61-1.05c-0.38-0.22-0.84-0.21-1.21,0.01l-0.09,0.05 c-1.18,0.7-1.91,1.99-1.91,3.36v2.27c0,0.55,0.3,1.05,0.78,1.31c0.22,0.12,0.46,0.18,0.7,0.18c0.29,0,0.57-0.08,0.82-0.25 c0.09-0.06,0.15-0.16,0.18-0.26L221.21,321.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M216.74,318.59c-0.15,0.06-0.31,0.05-0.45-0.03c-0.18-0.1-0.29-0.27-0.29-0.48v-2.27 c0-1.04,0.56-2.02,1.45-2.55l0.09-0.05c0.12-0.07,0.23-0.03,0.27,0c0.04,0.02,0.14,0.09,0.14,0.23c0,0.26,0.21,0.47,0.47,0.47 c0.26,0,0.47-0.21,0.47-0.47c0-0.44-0.23-0.83-0.61-1.05c-0.38-0.22-0.84-0.21-1.21,0.01l-0.09,0.05 c-1.18,0.7-1.91,1.99-1.91,3.36v2.27c0,0.55,0.3,1.05,0.78,1.31c0.22,0.12,0.46,0.18,0.7,0.18c0.29,0,0.57-0.08,0.82-0.25 c0.09-0.06,0.15-0.16,0.18-0.26L216.74,318.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M212.27,316.01c-0.15,0.06-0.31,0.05-0.45-0.03c-0.18-0.1-0.29-0.27-0.29-0.48v-2.27 c0-1.04,0.56-2.02,1.45-2.55l0.09-0.05c0.12-0.07,0.23-0.03,0.27,0c0.04,0.02,0.14,0.09,0.14,0.23c0,0.26,0.21,0.47,0.47,0.47 c0.26,0,0.47-0.21,0.47-0.47c0-0.44-0.23-0.83-0.61-1.05c-0.38-0.22-0.84-0.21-1.21,0.01l-0.09,0.05 c-1.18,0.7-1.91,1.99-1.91,3.36v2.27c0,0.55,0.3,1.05,0.78,1.31c0.22,0.12,0.46,0.18,0.7,0.18c0.29,0,0.57-0.08,0.82-0.25 c0.09-0.06,0.15-0.16,0.18-0.26L212.27,316.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M207.8,313.43c-0.15,0.06-0.31,0.05-0.45-0.03c-0.18-0.1-0.29-0.27-0.29-0.48v-2.27 c0-1.04,0.56-2.02,1.45-2.55l0.09-0.05c0.12-0.07,0.23-0.03,0.27,0c0.04,0.02,0.14,0.09,0.14,0.23c0,0.26,0.21,0.47,0.47,0.47 c0.26,0,0.47-0.21,0.47-0.47c0-0.44-0.23-0.83-0.61-1.05c-0.38-0.22-0.84-0.21-1.21,0.01l-0.09,0.05 c-1.18,0.7-1.91,1.99-1.91,3.36v2.27c0,0.55,0.3,1.05,0.78,1.31c0.22,0.12,0.46,0.18,0.7,0.18c0.29,0,0.57-0.08,0.82-0.25 c0.09-0.06,0.15-0.16,0.18-0.26L207.8,313.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M203.33,310.85c-0.15,0.06-0.31,0.05-0.45-0.03c-0.18-0.1-0.29-0.27-0.29-0.48v-2.27 c0-1.04,0.56-2.02,1.45-2.55l0.09-0.05c0.12-0.07,0.23-0.03,0.27,0c0.04,0.02,0.14,0.09,0.14,0.23c0,0.26,0.21,0.47,0.47,0.47 c0.26,0,0.47-0.21,0.47-0.47c0-0.44-0.23-0.83-0.61-1.05c-0.38-0.22-0.84-0.21-1.21,0.01l-0.09,0.05 c-1.18,0.7-1.91,1.99-1.91,3.36v2.27c0,0.55,0.3,1.05,0.78,1.31c0.22,0.12,0.46,0.18,0.7,0.18c0.29,0,0.57-0.08,0.82-0.25 c0.09-0.06,0.15-0.16,0.18-0.26L203.33,310.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M198.86,308.27c-0.15,0.06-0.31,0.05-0.45-0.03c-0.18-0.1-0.29-0.27-0.29-0.48v-2.27 c0-1.04,0.56-2.02,1.45-2.55l0.09-0.05c0.12-0.07,0.23-0.03,0.27,0c0.04,0.02,0.14,0.09,0.14,0.23c0,0.26,0.21,0.47,0.47,0.47 c0.26,0,0.47-0.21,0.47-0.47c0-0.44-0.23-0.83-0.61-1.05c-0.38-0.22-0.84-0.21-1.21,0.01l-0.09,0.05 c-1.18,0.7-1.91,1.99-1.91,3.36v2.27c0,0.55,0.3,1.05,0.78,1.31c0.22,0.12,0.46,0.18,0.7,0.18c0.29,0,0.57-0.08,0.82-0.25 c0.09-0.06,0.15-0.16,0.18-0.26L198.86,308.27z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E6E6"
    },
    points: "251.35,298.95 225.48,313.88 191.82,294.45 217.69,279.52  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    points: "252.83,298.46 225.81,311.18 193.89,288.99 220.92,276.28  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M192.5,258.75h-10.93h-11.02l1.97,23.23h0.01c0.12,1.24,0.98,2.46,2.62,3.4 c3.52,2.03,9.23,2.03,12.76,0c1.64-0.95,2.5-2.16,2.62-3.4h0.01L192.5,258.75z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M193.9,257.48v-1.84h-0.43c-0.54-1.17-1.6-2.28-3.19-3.2c-4.83-2.79-12.67-2.79-17.5,0 c-1.59,0.92-2.65,2.03-3.19,3.2h-0.43v1.86c0,1.83,1.21,3.66,3.63,5.05c4.83,2.79,12.67,2.79,17.5,0 C192.7,261.15,193.91,259.31,193.9,257.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M190.28,260.8c-4.83,2.79-12.67,2.79-17.5,0c-4.83-2.79-4.83-7.32,0-10.11 c4.83-2.79,12.67-2.79,17.5,0C195.11,253.49,195.11,258.01,190.28,260.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M191.45,254.98v-1.47h-0.35c-0.44-0.94-1.28-1.83-2.56-2.56c-3.87-2.24-10.15-2.24-14.03,0 c-1.28,0.74-2.12,1.62-2.56,2.56h-0.35v1.49c0,1.47,0.97,2.93,2.9,4.05c3.87,2.24,10.15,2.24,14.03,0 C190.48,257.92,191.45,256.45,191.45,254.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M188.54,257.64c-3.87,2.24-10.15,2.24-14.03,0c-3.87-2.24-3.87-5.86,0-8.1 c3.87-2.24,10.15-2.24,14.03,0C192.41,251.78,192.41,255.41,188.54,257.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M186.92,256.46c-2.97,1.72-7.81,1.72-10.8,0c-2.89-1.66-2.98-4.33-0.3-6.05 c0.1-0.07,0.2-0.13,0.3-0.19c0.62-0.36,1.33-0.64,2.09-0.85c2.84-0.79,6.36-0.51,8.71,0.85 C189.91,251.95,189.91,254.74,186.92,256.46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M176.13,251.12c2.98-1.72,7.82-1.72,10.8,0c1.3,0.75,2.03,1.7,2.2,2.67 c0.22-1.27-0.51-2.59-2.2-3.56c-2.98-1.72-7.82-1.72-10.8,0c-1.69,0.97-2.42,2.29-2.2,3.56 C174.1,252.81,174.83,251.86,176.13,251.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M180.21,251.41l-2.22,1.41l-2.16-1.55v-0.85c0.1-0.07,0.2-0.13,0.3-0.19 c0.62-0.36,1.33-0.64,2.09-0.85v0.64L180.21,251.41z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Screen"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.1515,
      strokeMiterlimit: 10
    },
    d: "M276,39.89"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M440.86,114.95L316.38,43.08c-1.43-0.82-2.71-0.76-3.62-0.01l-4.31,2.98l2.94,3.63v100.38 c0,3.68,2.24,7.95,4.99,9.54l123.24,71.15l0.23,3.92l4.54-3.11c0.9-0.68,1.46-2.03,1.46-3.86V124.49 C445.86,120.81,443.62,116.54,440.86,114.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M440.86,114.95L316.38,43.08c-1.43-0.82-2.71-0.76-3.62-0.01l-4.31,2.98l2.94,3.63v100.38 c0,3.68,2.24,7.95,4.99,9.54l123.24,71.15l0.23,3.92l4.54-3.11c0.9-0.68,1.46-2.03,1.46-3.86V124.49 C445.86,120.81,443.62,116.54,440.86,114.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M436.62,234.4l-124.48-71.87c-2.76-1.59-4.99-5.86-4.99-9.54V49.77c0-3.68,2.24-5.37,4.99-3.78 l124.48,71.87c2.76,1.59,4.99,5.86,4.99,9.54v103.22C441.62,234.3,439.38,235.99,436.62,234.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M436.62,234.4l-124.48-71.87c-2.76-1.59-4.99-5.86-4.99-9.54V49.77c0-3.68,2.24-5.37,4.99-3.78 l124.48,71.87c2.76,1.59,4.99,5.86,4.99,9.54v103.22C441.62,234.3,439.38,235.99,436.62,234.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M436.62,117.87L312.14,46c-2.76-1.59-4.99,0.1-4.99,3.78v5.05l134.47,77.64v-5.05 C441.62,123.73,439.38,119.46,436.62,117.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M310.16,46.4L310.16,46.4c0.44,0,0.96,0.16,1.48,0.47l124.48,71.87 c2.44,1.41,4.49,5.38,4.49,8.67v103.22c0,2.05-0.79,3.37-2.01,3.37c-0.45,0-0.95-0.16-1.48-0.47l-124.48-71.87 c-2.44-1.41-4.49-5.38-4.49-8.68V49.77C308.15,47.72,308.94,46.4,310.16,46.4 M310.16,45.4c-1.77,0-3.01,1.64-3.01,4.37v103.22 c0,3.68,2.24,7.95,4.99,9.54l124.48,71.87c0.7,0.41,1.37,0.6,1.98,0.6c1.77,0,3.01-1.64,3.01-4.37V127.41 c0-3.68-2.24-7.95-4.99-9.54L312.14,46C311.44,45.59,310.77,45.4,310.16,45.4L310.16,45.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M364.86,100.04c-0.18,0-0.36-0.05-0.53-0.14l-47.38-27.36c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l47.38,27.36c0.51,0.29,0.68,0.94,0.39,1.45C365.58,99.85,365.22,100.04,364.86,100.04z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M431.53,138.54c-0.18,0-0.36-0.05-0.53-0.14l-35.1-20.26c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l35.1,20.26c0.51,0.29,0.68,0.94,0.39,1.45C432.25,138.35,431.89,138.54,431.53,138.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M388.82,113.88c-0.18,0-0.36-0.05-0.53-0.14l-14.26-8.23c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l14.26,8.23c0.51,0.29,0.68,0.94,0.39,1.45C389.54,113.69,389.18,113.88,388.82,113.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M364.86,166.41c-0.18,0-0.36-0.05-0.53-0.14l-47.38-27.36c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l47.38,27.36c0.51,0.29,0.68,0.94,0.39,1.45C365.58,166.22,365.22,166.41,364.86,166.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M431.53,204.9c-0.18,0-0.36-0.05-0.53-0.14l-35.1-20.27c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l35.1,20.27c0.51,0.29,0.68,0.94,0.39,1.45C432.25,204.71,431.89,204.9,431.53,204.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M388.82,180.24c-0.18,0-0.36-0.05-0.53-0.14l-14.26-8.23c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l14.26,8.23c0.51,0.29,0.68,0.94,0.39,1.45C389.54,180.05,389.18,180.24,388.82,180.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M364.86,182.01c-0.18,0-0.36-0.05-0.53-0.14l-47.38-27.36c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l47.38,27.36c0.51,0.29,0.68,0.94,0.39,1.45C365.58,181.82,365.22,182.01,364.86,182.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M416.59,211.88c-0.18,0-0.36-0.05-0.53-0.14L395.9,200.1c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l20.16,11.64c0.51,0.29,0.68,0.94,0.39,1.45C417.31,211.69,416.95,211.88,416.59,211.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M388.82,195.85c-0.18,0-0.36-0.05-0.53-0.14l-14.26-8.23c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l14.26,8.23c0.51,0.29,0.68,0.94,0.39,1.45C389.54,195.66,389.18,195.85,388.82,195.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M341.23,94.65c-0.18,0-0.36-0.05-0.53-0.14l-23.75-13.71c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l23.75,13.71c0.51,0.29,0.68,0.94,0.39,1.45C341.95,94.46,341.59,94.65,341.23,94.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M409.66,134.16c-0.18,0-0.36-0.05-0.53-0.14l-35.1-20.26c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l35.1,20.26c0.51,0.29,0.68,0.94,0.39,1.45C410.38,133.97,410.03,134.16,409.66,134.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M365.19,108.48c-0.18,0-0.36-0.05-0.53-0.14l-14.26-8.23c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l14.26,8.23c0.51,0.29,0.68,0.94,0.39,1.45C365.91,108.29,365.55,108.48,365.19,108.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M364.86,116.54c-0.18,0-0.36-0.05-0.53-0.14l-47.38-27.36c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l47.38,27.36c0.51,0.29,0.68,0.94,0.39,1.45C365.58,116.35,365.22,116.54,364.86,116.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M405.78,140.16c-0.18,0-0.36-0.05-0.53-0.14l-9.35-5.4c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l9.35,5.4c0.51,0.29,0.68,0.94,0.39,1.45C406.5,139.97,406.14,140.16,405.78,140.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M345.9,113.84c-0.18,0-0.36-0.05-0.53-0.14l-9.35-5.4c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l9.35,5.4c0.51,0.29,0.68,0.94,0.39,1.45C346.62,113.65,346.27,113.84,345.9,113.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M388.82,130.37c-0.18,0-0.36-0.05-0.53-0.14L374.03,122c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l14.26,8.23c0.51,0.29,0.68,0.94,0.39,1.45C389.54,130.18,389.18,130.37,388.82,130.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M332.66,106.19c-0.18,0-0.36-0.05-0.53-0.14l-15.19-8.77c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l15.19,8.77c0.51,0.29,0.68,0.94,0.39,1.45C333.38,106,333.03,106.19,332.66,106.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M365.19,124.97c-0.18,0-0.36-0.05-0.53-0.14l-14.26-8.23c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l14.26,8.23c0.51,0.29,0.68,0.94,0.39,1.45C365.91,124.78,365.55,124.97,365.19,124.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M364.86,133.63c-0.18,0-0.36-0.05-0.53-0.14l-47.38-27.36c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l47.38,27.36c0.51,0.29,0.68,0.94,0.39,1.45C365.58,133.44,365.22,133.63,364.86,133.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M431.53,172.12c-0.18,0-0.36-0.05-0.53-0.14l-35.1-20.26c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l35.1,20.26c0.51,0.29,0.68,0.94,0.39,1.45C432.25,171.93,431.89,172.12,431.53,172.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M388.82,147.46c-0.18,0-0.36-0.05-0.53-0.14l-14.26-8.23c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l14.26,8.23c0.51,0.29,0.68,0.94,0.39,1.45C389.54,147.27,389.18,147.46,388.82,147.46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M341.23,128.23c-0.18,0-0.36-0.05-0.53-0.14l-23.75-13.71c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l23.75,13.71c0.51,0.29,0.68,0.94,0.39,1.45C341.95,128.04,341.59,128.23,341.23,128.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M409.66,167.75c-0.18,0-0.36-0.05-0.53-0.14l-35.1-20.26c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l35.1,20.26c0.51,0.29,0.68,0.94,0.39,1.45C410.38,167.56,410.03,167.75,409.66,167.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M365.19,142.07c-0.18,0-0.36-0.05-0.53-0.14l-14.26-8.23c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l14.26,8.23c0.51,0.29,0.68,0.94,0.39,1.45C365.91,141.88,365.55,142.07,365.19,142.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M364.86,150.12c-0.18,0-0.36-0.05-0.53-0.14l-47.38-27.36c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l47.38,27.36c0.51,0.29,0.68,0.94,0.39,1.45C365.58,149.93,365.22,150.12,364.86,150.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M405.78,173.75c-0.18,0-0.36-0.05-0.53-0.14l-9.35-5.4c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l9.35,5.4c0.51,0.29,0.68,0.94,0.39,1.45C406.5,173.56,406.14,173.75,405.78,173.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M345.9,147.43c-0.18,0-0.36-0.05-0.53-0.14l-9.35-5.4c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l9.35,5.4c0.51,0.29,0.68,0.94,0.39,1.45C346.62,147.24,346.27,147.43,345.9,147.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M388.82,163.96c-0.18,0-0.36-0.05-0.53-0.14l-14.26-8.23c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l14.26,8.23c0.51,0.29,0.68,0.94,0.39,1.45C389.54,163.77,389.18,163.96,388.82,163.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M332.66,139.78c-0.18,0-0.36-0.05-0.53-0.14l-15.19-8.77c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l15.19,8.77c0.51,0.29,0.68,0.94,0.39,1.45C333.38,139.59,333.03,139.78,332.66,139.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M365.19,158.56c-0.18,0-0.36-0.05-0.53-0.14l-14.26-8.23c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l14.26,8.23c0.51,0.29,0.68,0.94,0.39,1.45C365.91,158.37,365.55,158.56,365.19,158.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M345.9,163.23c-0.18,0-0.36-0.05-0.53-0.14l-9.35-5.4c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l9.35,5.4c0.51,0.29,0.68,0.94,0.39,1.45C346.62,163.04,346.27,163.23,345.9,163.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M332.66,155.59c-0.18,0-0.36-0.05-0.53-0.14l-15.19-8.77c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l15.19,8.77c0.51,0.29,0.68,0.94,0.39,1.45C333.38,155.4,333.03,155.59,332.66,155.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M365.19,174.37c-0.18,0-0.36-0.05-0.53-0.14L350.4,166c-0.51-0.29-0.68-0.94-0.39-1.45 c0.29-0.51,0.94-0.68,1.45-0.39l14.26,8.23c0.51,0.29,0.68,0.94,0.39,1.45C365.91,174.18,365.55,174.37,365.19,174.37z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M326.85,82.83v38.34c0,0.62-0.23,1.03-0.57,1.16l-0.01,0l0,0l-1.47,0.8l0.01-1.31l-0.21-39.42 l1.92-0.97C326.73,81.89,326.85,82.37,326.85,82.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M326.52,81.45l-1.92,0.97l-46.49-27.25L277,54.52l1.53-0.86l0.04-0.03v0 c0.24-0.15,0.56-0.14,0.92,0.07l45.98,26.49C325.89,80.43,326.27,80.9,326.52,81.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M325.19,83.66v38.09c0,0.53-0.17,0.91-0.44,1.09l-0.09,0.05c-0.23,0.11-0.53,0.09-0.85-0.1 l-45.7-26.33c-0.76-0.44-1.38-1.62-1.38-2.63V55.75c0-0.51,0.16-0.88,0.41-1.07c0.04-0.03,0.09-0.06,0.14-0.08 c0.23-0.1,0.52-0.07,0.83,0.11l45.7,26.33c0.4,0.23,0.77,0.68,1.02,1.19C325.05,82.68,325.19,83.19,325.19,83.66z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(-0.866 -0.5 0 1 316.9501 108.3479)",
    style: {
      fill: "#FAFAFA",
      fontFamily: "'Montserrat-Bold'",
      fontSize: "25.7999px"
    }
  }, "&lt;/&gt;")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M277.38,54.64c0.13,0,0.27,0.04,0.42,0.13l45.98,26.49c0.35,0.2,0.68,0.6,0.92,1.09 c0.21,0.44,0.33,0.91,0.33,1.33V122c0,0.42-0.12,0.75-0.31,0.87l-0.08,0.04c-0.06,0.03-0.13,0.04-0.2,0.04 c-0.13,0-0.27-0.04-0.42-0.13l-45.98-26.49c-0.68-0.39-1.26-1.5-1.26-2.42V55.6c0-0.41,0.11-0.73,0.31-0.87 c0.03-0.02,0.06-0.04,0.09-0.05C277.26,54.65,277.32,54.64,277.38,54.64 M277.38,54.38c-0.1,0-0.19,0.02-0.28,0.06 c-0.05,0.02-0.1,0.05-0.14,0.08c-0.26,0.19-0.41,0.56-0.41,1.08v38.32c0,1.02,0.62,2.2,1.38,2.64l45.98,26.49 c0.19,0.11,0.38,0.17,0.55,0.17c0.11,0,0.21-0.02,0.31-0.07l0.09-0.05c0.27-0.18,0.44-0.56,0.44-1.1V83.68 c0-0.48-0.14-0.99-0.36-1.44c-0.25-0.52-0.62-0.96-1.02-1.2l-45.98-26.49C277.74,54.44,277.55,54.38,277.38,54.38L277.38,54.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M319.46,55.63c0,1.09-0.77,1.53-1.71,0.99c-0.94-0.55-1.71-1.87-1.71-2.96s0.77-1.53,1.71-0.99 C318.69,53.21,319.46,54.54,319.46,55.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M325.82,59.55c0,1.09-0.77,1.53-1.71,0.99c-0.94-0.55-1.71-1.87-1.71-2.96s0.77-1.53,1.71-0.99 C325.05,57.14,325.82,58.46,325.82,59.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M332.17,63.48c0,1.09-0.77,1.53-1.71,0.99c-0.94-0.55-1.71-1.87-1.71-2.96s0.77-1.53,1.71-0.99 C331.41,61.06,332.17,62.39,332.17,63.48z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB1);
export default __webpack_public_path__ + "static/media/b1.a9756f8afa395bbe911d67ac893e1860.svg";
export { ForwardRef as ReactComponent };